import styled from 'styled-components';
import listMinusIcon from './listMinusIcon.svg';

// Implementation inspired by: https://medium.com/@ians/rendering-svgs-as-images-directly-in-react-a26615c45770

const encodedListMinusIcon = Buffer.from(listMinusIcon).toString('base64');

export const ListMinusIcon = styled.div({
  background: `url("data:image/svg+xml;base64,${encodedListMinusIcon}")`,
  backgroundRepeat: 'no-repeat',
  minWidth: '20px',
  width: '20px',
  height: '20px'
});
